/**
 * Checkbox - Reusable checkbox component
 *
 * Used for legal agreements and other forms
 */

import { ReactNode } from 'react';

interface CheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  required?: boolean;
  children: ReactNode;
}

export function Checkbox({ checked, onChange, required = false, children }: CheckboxProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.checked);
  };

  return (
    <label className="checkbox-container">
      <input
        type="checkbox"
        checked={checked}
        onChange={handleChange}
        className="checkbox-input"
      />
      <span className="checkbox-checkmark"></span>
      <span className="checkbox-label">
        {children}
        {required && <span className="checkbox-required"> *</span>}
      </span>
    </label>
  );
}
